import { DEFAULT_WRITE_MODEL, WRITE_MODELS } from "../../../src/shared/constants";
import { getSelectedWriteModel, getWriteModelSelectionOptions } from "../components/BenchmarkTakeover/proseMode";
import { useSudowriteStore } from "../stores/sudowriteStore";

interface WriteModelOptions {
  editorOptions?: {
    writeModel?: string | null;
    hasChangedWriteDefault?: boolean | null;
  } | null;
  initialWriteModel?: string | null;
}

// The picker and new Write/Guided Write requests must resolve the same model,
// including defaults for accounts that have not explicitly chosen a mode.
export default function useWriteModel({ editorOptions, initialWriteModel }: WriteModelOptions): string {
  const subscription = useSudowriteStore((state) => state.subscription);
  const userData = useSudowriteStore((state) => state.userData);
  const isInUnlimitedExperiment = useSudowriteStore((state) => state.isInUnlimitedExperiment);
  const unlimitedExperimentVariation = useSudowriteStore((state) => state.unlimitedExperimentVariation);
  const selectionOptions = getWriteModelSelectionOptions({ subscription, isInUnlimitedExperiment, unlimitedExperimentVariation });
  const baseDefault = selectionOptions.fallbackModel;

  // Account choices follow the user across projects; old project model
  // preferences must not override either an account choice or its defaults.
  const savedModel = getSelectedWriteModel(editorOptions?.writeModel ?? initialWriteModel, undefined, selectionOptions) || baseDefault;
  const hasExplicitChoice = editorOptions?.hasChangedWriteDefault || userData?.data?.hasChangedWriteDefault;
  const model = hasExplicitChoice || savedModel === "myVoice" ? savedModel : baseDefault;

  return subscription?.usesLedgers && !WRITE_MODELS.some((entry) => entry.value === model)
    ? DEFAULT_WRITE_MODEL
    : model;
}
